var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M375.27 1.94C318.06 1.94 266.67 33.94 238.55 84.36C177.45 56.24 107.64 100.85 103.76 170.67C45.58 180.36 1.94 233.7 1.94 295.76C1.94 365.58 57.21 421.82 124.12 421.82C125.61 421.82 133.04 421.82 146.42 421.82C146.42 546.91 146.42 616.4 146.42 630.3C146.42 630.3 146.42 630.3 146.42 630.3C146.42 630.3 146.42 630.3 146.42 630.3C146.42 634.18 150.3 638.06 154.18 638.06C177.71 638.06 295.37 638.06 507.15 638.06C507.15 638.06 507.15 638.06 507.15 638.06C511.03 638.06 514.91 635.15 514.91 630.3C514.91 609.45 514.91 442.67 514.91 421.82C585.7 421.82 638.06 363.64 638.06 295.76C638.06 232.73 593.45 180.36 533.33 170.67C537.21 83.39 467.39 1.94 375.27 1.94ZM287.03 540.12L161.94 616.73L161.94 421.82L287.03 540.12ZM171.64 412.12L488.73 412.12C393.89 501.72 341.2 551.5 330.67 561.45C296.73 529.45 321.94 553.7 183.27 422.79C181.72 421.37 177.84 417.81 171.64 412.12ZM499.39 421.82L499.39 616.73L374.3 540.12L499.39 421.82ZM324.85 576.97C327.76 579.88 331.64 579.88 334.55 576.97C336.36 575.22 345.41 566.5 361.7 550.79L480 622.55L180.36 622.55L297.7 550.79C313.99 566.5 323.04 575.22 324.85 576.97ZM513.94 404.36C513.94 400.48 511.03 396.61 506.18 396.61C470.98 396.61 189.38 396.61 154.18 396.61C150.3 396.61 146.42 399.52 146.42 404.36C146.42 404.56 146.42 405.53 146.42 407.27C133.04 407.27 125.61 407.27 124.12 407.27C64.97 407.27 17.45 357.82 17.45 295.76C17.45 238.55 58.18 191.03 112.48 184.24C116.36 184.24 119.27 179.39 119.27 176.48C119.27 112.48 185.21 71.76 239.52 100.85C243.39 102.79 247.27 101.82 249.21 97.94C273.45 47.52 322.91 16.48 376.24 16.48C459.64 16.48 525.58 90.18 518.79 176.48C518.79 180.36 521.7 184.24 525.58 184.24C580.85 189.09 623.52 237.58 623.52 295.76C623.52 355.88 576.97 407.27 513.94 407.27C513.94 406.69 513.94 404.65 513.94 404.36Z",
    id: "d2RZZvC52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 275.39C307.39 275.39 294.79 280.24 286.06 289.94C267.64 308.36 267.64 339.39 286.06 357.82C304.48 376.24 335.52 376.24 353.94 357.82C353.94 357.82 353.94 357.82 353.94 357.82C372.36 339.39 372.36 308.36 353.94 289.94C345.21 281.21 332.61 275.39 320 275.39C320 275.39 320 275.39 320 275.39ZM343.27 347.15C330.67 359.76 308.36 359.76 295.76 347.15C283.15 334.55 283.15 313.21 295.76 299.64C308.36 287.03 329.7 286.06 343.27 299.64C356.85 313.21 356.85 334.55 343.27 347.15C343.27 347.15 343.27 347.15 343.27 347.15Z",
    id: "d6v2AO02Z5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.7 259.88C236.61 262.79 241.45 262.79 244.36 259.88C287.03 217.21 354.91 217.21 397.58 259.88C400.48 262.79 405.33 262.79 408.24 259.88C411.15 256.97 411.15 252.12 408.24 249.21C358.79 200.73 281.21 200.73 233.7 249.21C230.79 252.12 230.79 256.97 233.7 259.88Z",
    id: "caTLu1uZJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.85 212.36C193.94 215.27 193.94 220.12 196.85 223.03C199.76 225.94 204.61 225.94 207.52 223.03C269.58 160 371.39 160 433.45 223.03C436.36 225.94 441.21 225.94 444.12 223.03C447.03 220.12 447.03 215.27 444.12 212.36C384.97 153.21 310.3 160.97 320 160.97C273.45 160.97 229.82 179.39 196.85 212.36Z",
    id: "drYCBecYt"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2RZZvC52",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2RZZvC52",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d6v2AO02Z5",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d6v2AO02Z5",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#caTLu1uZJ",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#caTLu1uZJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drYCBecYt",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drYCBecYt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail4);
export default __webpack_public_path__ + "static/media/email-4.b4692c6c79a64861592860d279bef69f.svg";
export { ForwardRef as ReactComponent };